import SourcingAgent from './sourcingAgent';
import SourcingCampaigns from './sourcingCampaigns';
import SourcingCampaign from './sourcingCampaign';

export const sourcingAgentRoutes = {
  sourcingAgent: {
    path: ['/sourcing-agent', '/sourcing-agent/campaigns'],
    component: SourcingCampaigns,
    name: 'Sourcing Agent',
    exact: true,
  },
  sourcingCampaign: {
    path: '/sourcing-agent/campaigns/:id',
    component: SourcingCampaign,
    name: 'Campaign Details',
    exact: true,
  },
};

export { SourcingAgent, SourcingCampaigns, SourcingCampaign };
